import { PageScrollWrap } from 'commonStyledComponents'
import styled from 'styled-components'

export const ShortWrap = styled(PageScrollWrap)`
  --cms-grid-gap-width: 0.02rem;
  --component-video-box-vertical--border-radius: 0;
`
